/** La Tostadora–style cart icon with red count badge. */
export function CartButton({
  count,
  href,
  className = '',
}: {
  count: number;
  href?: string;
  className?: string;
}) {
  const url = href || '/cart/';
  const label = count > 0 ? `Carrito, ${count} artículos` : 'Carrito';

  return (
    <a
      className={`ox-cart-btn ${className}`.trim()}
      href={url}
      aria-label={label}
      title="Ver carrito"
    >
      <span className="ox-cart-ico" aria-hidden>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M3 5h1.5l1.2 2M6 12h11l2-5H6.5M6 12l-1 5h13M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {count > 0 && (
        <span className="ox-cart-badge" aria-hidden>
          {count > 99 ? '99+' : count}
        </span>
      )}
    </a>
  );
}
